import { SearchUserEnriched } from 'lib-search-types';

/** Checks whether an agent has the phone channel enabled. */
export function isAgentAvailableOnPhoneChannel(
  member: SearchUserEnriched,
): boolean {
  return member.working_media_types?.includes('speak') ?? false;
}
